"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findValueForKey = findValueForKey;
/*! Copyright (c) 2019, XAPPmedia */
const array_1 = require("../array");
const findValuesForKey_1 = require("./findValuesForKey");
/**
 * Searches the provided object for the provided key.
 *
 * Smarter than a normal obj[key] as key can also be a regex.
 *
 * In the cases where a regex is broad (".*") but there is also an exact match,
 * the exact match is preferred.
 *
 * @param {string} key
 * @param {ObjectWithKeys<V>} obj
 * @returns {(V | undefined)}
 */
function findValueForKey(key, obj) {
    if (!key) {
        return undefined;
    }
    if (!obj) {
        return undefined;
    }
    // Look for an exact match
    const exactMatch = obj[key] ? obj[key] : undefined;
    // Look for a regex match
    let regexMatch;
    if (!exactMatch) {
        // only if we don't have an exact already
        const regexMatches = (0, findValuesForKey_1.findValuesForKey)(key, obj);
        if ((0, array_1.existsAndNotEmpty)(regexMatches)) {
            regexMatch = regexMatches.pop();
        }
    }
    // Return what you find.
    return exactMatch || regexMatch;
}
//# sourceMappingURL=findValueForKey.js.map